// extracted by mini-css-extract-plugin
export default {"productCard":"productcard_productCard__vc76s","info":"productcard_info__dJgCc","card":"productcard_card__E21TO"};